<div
  class="loading-container loading-container-{{ align }}"
  #loadingContainer>
  <div
    class="img"
    theming
    themingGroup="none"
    [themingAsset]="loaderAsset()">
    <div
      class="img img-circle"
      theming
      themingGroup="none"
      themingAsset="loading"></div>
  </div>
</div>
